import React, { useContext, useRef } from "react";
import classes from "./BlogsList.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import BlogsCard from "./blogs-card/BlogsCard";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../App";

const BlogsList = ({data}) => {
  const swiperRef = useRef(null);
  const width = useDeviceWidth();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const navigate = useNavigate();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  return (
    <div className={`${classes.outer}`} id="news-events">
      <div className={classes.inner}>
        <img src="/img/blogs-pattern.svg" alt="pattern" className={classes.pattern}></img>
        <div className={classes.innerContent}>
          <div className={classes.title} data-aos="fade-down" data-aos-delay="200">
            <h1 className="bg-primary-200 primary-300">{data?.subTitle}</h1>
            {data?.showTitle && (
            <div>
              <h2 dangerouslySetInnerHTML={{ __html: data?.title }}></h2>
            </div>
            )}
            {/* <div className={`${classes.underLine} bg-primary-500`}></div> */}
          </div>
          <div className={classes.sliderOuter}>
            <div className={classes.arrowDiv}>
              <img
                src="/img/title-symbol.svg"
                alt="symbol"
                className={classes.titleSymbol}
              ></img>
              <div className={classes.arrows}>
                <img
                  className={classes.leftArrow}
                  src="/img/doctor-left.svg"
                  alt="Prev"
                  onClick={() => swiperRef.current?.slidePrev()} // Trigger previous slide
                />
                <img
                  src="/img/doctor-right.svg"
                  className={classes.rightArrow}
                  alt="Next"
                  onClick={() => swiperRef.current?.slideNext()} // Trigger next slide
                />
              </div>
            </div>
            <div className="outer-outer">
              <div>
                {/* Custom Navigation Arrows */}

                {/* Swiper */}
                <Swiper
                  //   modules={[Navigation, Pagination]}
                  slidesPerView={
                    width > 1800
                      ? 5
                      : width > 1200
                      ? 4
                      : width > 900
                      ? 3
                      : width > 550
                      ? 2
                      : 1
                  }
                  spaceBetween={20} // Add space between slides
                  onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
                  pagination={{ clickable: true }} // Enable clickable dots
                  loop={true} // Enable infinite looping
                  draggable={true} // Enable drag/swipe functionality
                  modules={[Autoplay]}
                  autoplay={{
                    delay: 3000, // 3 seconds
                    disableOnInteraction: false, // Autoplay continues even after interaction
                  }}
                >
                  {data?.listingItems?.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <BlogsCard data = {slide} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
          <div className={classes.buttonDiv}>
          <button
              className={`${classes.viewAll} border-primary-500 primaryHover`}
              onClick={() => {
                 const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              setIsBackNavigation(true)
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
                navigate(`/blogs`)}}
            >
              View All News & Events
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogsList;
